import styled    from 'styled-components';
import { Modal } from '@shared/components/modals/Modal';

const AuctionInfoContainer = styled.div`
  display        : flex;
  flex-direction : column;
`;

const RowWrapper = styled.div`
  display: flex;

  div {
    display : flex;
    flex    : 1;
    margin  : 0 0 0 5px;
  }

  div:first-child {
    justify-content : end;
    margin          : 0 5px 0 0;
    font-weight     : 700;
  }
`;

const NoInfoWrapper = styled.div`
    align-self: center;
`;

export const ViewAdditionalInfoModal = ({ additionalInfo, handleClose }: {
    additionalInfo : { [key: string]: string };
    handleClose    : () => void;
}) => (
  <Modal
    open
    dialogMinHeight = "500px"
    dialogWidth     = "500px"
    title           = "Additional Contact Info"
    onClose         = {handleClose}
  >
    {Object.keys(additionalInfo).length ? (
      <AuctionInfoContainer>
        {Object.keys(additionalInfo).map((key) => (
          <RowWrapper key={key}>
            <div>{key}:</div>
            <div>{additionalInfo[key]}</div>
          </RowWrapper>
        ))}
      </AuctionInfoContainer>
    ) : (
      <NoInfoWrapper>No additional info.</NoInfoWrapper>
    )}
  </Modal>
);
